import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import urls from "../../../urls";
import styled from "styled-components";
import { formatCategoryName } from "../../../helpers/formatters";
import { colors } from "../../../utils/theme";
import { useUserProfile } from "../../hooks/firestore/useUserProfile";
import { useCategories } from "../../hooks/firestore/useCategories";

const MobileNavMenuShop = ({ closeMenu }) => {
  const { t, i18n } = useTranslation();
  const { data: profile } = useUserProfile();
  const { data: categories, isLoading } = useCategories();
  const isSalesPerson = !!profile && profile.isSalesPerson;
  return (
    <StyledNav>
      <ul>
        <li>
          <MenuItem to={urls.shop} onClick={closeMenu}>
            {t("all_products")}
          </MenuItem>
        </li>
        {!isLoading &&
          !!categories &&
          categories.length > 0 &&
          categories.map((category, index) => (
            <li key={index}>
              <MenuItem to={urls.categorySlug + category.slug} onClick={closeMenu}>
                {formatCategoryName(category, i18n.language)}
              </MenuItem>
            </li>
          ))}
        <Divider />
        <li>
          <MenuItem to={urls.my_account} onClick={closeMenu}>
            {t("my_account")}
          </MenuItem>
        </li>
        <li>
          <MenuItem to={urls.my_orders} onClick={closeMenu}>
            {t("my_orders")}
          </MenuItem>
        </li>
        {isSalesPerson && (
          <li>
            <MenuItem to={urls.sales_clients} onClick={closeMenu}>
              {t("sales.my_clients")}
            </MenuItem>
          </li>
        )}
      </ul>
    </StyledNav>
  );
};

const Divider = styled.div`
  border-bottom: 1px solid #d9d9d9;
  margin: 1rem 0;
`;

const MenuItem = styled(Link)`
  display: block;
  font-size: 20px;
  letter-spacing: 0.5px;
  font-weight: 500;
  padding: 0.65rem 0;
  color: ${colors.menu_items};
`;

const StyledNav = styled.nav`
  padding: 0 1rem 3rem 2rem;
`;

export default MobileNavMenuShop;
